import { ReactNode } from 'react'
import styled from 'styled-components'

export const StyledErrorLabel = styled.span`
  color: red;
  font-size: 11px;
`

export const ErrorLabel = ({ children }: { children: ReactNode }) => {
  return <StyledErrorLabel>{children}</StyledErrorLabel>
}
